import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router/router';
import VueScrollactive from 'vue-scrollactive';
import "hooper/dist/hooper.css";
import './assets/scss/style.scss'

Vue.config.productionTip = false
Vue.use(VueScrollactive);


new Vue({
    vuetify,
    router,
    render: h => h(App),
}).$mount('#app')